import gql from 'graphql-tag';

export const GET_CUSTOMER_CREDIT_APPS = gql`
  query GetCustomerCreditApps($customerAccountId: ID!) {
    customer {
      customerCreditApps(customerAccountId: $customerAccountId) {
        error
        success
        list {
          creditApplicationId
          applyingFor
          createdDateTime

          location {
            locationId
            locationName
            category
          }

          owners {
            ownerPgId
            firstName
            lastName
            title
            signature
            signatureDate
          }

          vendorOpportunity {
            vendorOpportunityId
            equipmentDescription

            salesRepresentative {
              fullName
            }
          }
        }
      }
    }
  }
`;
